import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import type { AuthExtras } from "../types/auth";

export async function getMyPermissions(): Promise<AuthExtras> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<undefined, AuthExtras>(functions, "getMyPermissions");
  const result = await callable();
  return result.data;
}
